import script from "./PlantAndEquipment.vue?vue&type=script&setup=true&lang=js"
export * from "./PlantAndEquipment.vue?vue&type=script&setup=true&lang=js"

import "./PlantAndEquipment.vue?vue&type=style&index=0&id=70f02352&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70f02352"]])

export default __exports__